import type { UIState } from "@/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UIStore extends UIState {
  // Actions
  setSidebarCollapsed: (collapsed: boolean) => void;
  setCurrentTenant: (tenant: string | null) => void;
  setTheme: (theme: "light" | "dark") => void;
  setLastVisitedPage: (page: string) => void;
  setSelectedBookingFlow: (flow: string | null) => void;
  setSelectedAnalyticsUserEmail: (email: string | null) => void;

  // State
  selectedAnalyticsUserEmail: string | null;

  // Computed values
  isSidebarExpanded: boolean;
}

export const useUIStore = create<UIStore>()(
  persist(
    (set, get) => ({
      // Initial state
      sidebarCollapsed: false,
      currentTenant: null,
      theme: "light",
      lastVisitedPage: null,
      selectedBookingFlow: null,
      selectedAnalyticsUserEmail: null,

      // Computed
      get isSidebarExpanded() {
        return !get().sidebarCollapsed;
      },

      // Actions
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
      setCurrentTenant: (tenant) => set({ currentTenant: tenant }),
      setTheme: (theme) => set({ theme }),
      setLastVisitedPage: (page) => set({ lastVisitedPage: page }),
      setSelectedBookingFlow: (flow) => set({ selectedBookingFlow: flow }),
      setSelectedAnalyticsUserEmail: (email) =>
        set({ selectedAnalyticsUserEmail: email }),
    }),
    {
      name: "admin-ui-v2-state",
      partialize: (state) => ({
        sidebarCollapsed: state.sidebarCollapsed,
        currentTenant: state.currentTenant,
        theme: state.theme,
        lastVisitedPage: state.lastVisitedPage,
        selectedBookingFlow: state.selectedBookingFlow,
        selectedAnalyticsUserEmail: state.selectedAnalyticsUserEmail,
      }),
    },
  ),
);
